export default __webpack_public_path__ + "static/media/4.81b90cd7.jpg";